import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'

import { getToken } from '@/utils/auth'
/* Layout */
import Layout from '@/layout'

// 公共路由
export const defaultRouterList = [

    {
        path: "/:pathMatch(.*)*",
        redirect:'/404',
    },
    {
        path: "/404",
        name: "NotFound",
        component: () => import("@/views/404/index")
    },

    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/home/login'),
        meta: {
            title: '注册登录'
        },
    },
    {
        path: '/rest-password',
        name: 'rest-password',
        component: () => import('@/views/rest-password/index'),
        meta: {
            title: '重置密码'
        },
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('@/views/register/index'),
        meta: {
            title: '账号注册'
        },
    },
    {
        path: '/register-agreement',
        name: 'register-agreement',
        component: () => import('@/views/register-agreement/index'),
        meta: {
            title: '服务协议'
        },
    },
    {
        path: '/rest-phone',
        name: 'rest-phone',
        component: () => import('@/views/rest-phone/index'),
        meta: {
            title: '修改手机号'
        },
    },
    {
        path: '/user-center',
        name: 'user-center',
        component: () => import('@/views/user-center'),
        meta: {
          requiresAuth: true,
          title: '用户中心'
        }
    },
    {
        path: '/user-center/activation-codes',
        component: () => import('@/views/user-center/activation-codes'),
        meta: { requiresAuth: true }
      },
      {
        path: '/order-detail/:orderId',
        name: 'OrderDetail',
        component: () => import('@/views/user-center/order-detail'),
        meta: { requiresAuth: true }
      },

    {
        path: '',
        component: Layout,
        redirect: '/index',
        children: [
            {
                path: '/index',
                name: 'index',
                component: () => import('@/views/home/index'),
                meta: {
                    title: '首页',
                    nav: 'index'
                },
            },
            {
                path: '/download',
                name: 'download',
                component: () => import('@/views/home/download'),
                meta: {
                    title: '软件下载',
                    nav: 'download'
                },
            },

            // {
            //     path: '/open_beta',
            //     name: 'open_beta',
            //     component: () => import('@/views/home/open_beta'),
            //     meta: {
            //         title: '购买激活码',
            //         nav: 'open_beta'
            //     },
            // },
        ],
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes: defaultRouterList,
    scrollBehavior() {
        return {
            el: '#app',
            top: 0,
            behavior: 'smooth',
        }
    },
})

router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth && !getToken()) {
      next('/login')
    } else {
      next()
    }
  })

export default router
